export const EditStatus = {
    SUCCESS: 1,
    FAILED: 2,
    CANCELLED: 3
  };